import { render, staticRenderFns } from "./CustomAttribute.vue?vue&type=template&id=259f7f60"
import script from "./CustomAttribute.vue?vue&type=script&lang=js"
export * from "./CustomAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports